<template>
    <div id="CongresoRec">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                <strong>IV CONGRESO INTERNACIONAL DE EDUCACIÓN</strong><br>
                La Educación del Mundo se Conecta en Tucumán
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">


                <!-- Respuestas -->
                <div v-if="!visible" class="el-col el-col-24">
                    <div style="margin-top:30px; border:1px solid #ccc; padding:30px; font-size:16px; background-color:rgba(255,255,255,0.3)">
                        <center><strong>Respuestas Recuperación</strong></center><hr>
                        <ol>
                            <li v-for="(item,index) in Recuperacion" :key="index">
                                <span :class="'color-' + item.Tipo">{{ item.Pregunta }} <i><small>({{ item.Disertante }})</small></i></span>
                            </li>
                        </ol>
                    </div>
                </div>


                <!-- Pregunta -->
                <div v-if="visible" class="el-col el-col-24" style="margin-top:30px; font-size:18px">
                    <h2>{{ idBloque }}º Bloque - Recuperación</h2>
                    <div style="width:100%; padding:10px; background-color:#FFE500; color:#FF4C00; font-weight:bold; margin-top:30px; margin-bottom:50px; text-align:center">
                        Para aprobar debe contestar correctamente el 100% de las Preguntas.
                    </div>
                    <div style="text-align:justify">
                        <span v-html="Pregunta.Pregunta"></span>
                        <br><br>
                    </div>
                    <el-checkbox v-for="(item, index) in Respuestas"
                    :key="index" v-model="item.checked" style="width:100%; font-size:16px">
                        {{ item.Respuesta }}<br>
                    </el-checkbox>
                    <br><br>
                    <v-col class="col-12">
                        <v-btn 
                            raised 
                            block
                            color="green" 
                            :loading="cargando" 
                            :disabled="!BtnActivo"
                            @click="Submit()"
                            style="color:#fff"
                        >
                            Enviar Respuesta
                        </v-btn>
                    </v-col>
                </div>


                <!-- Resultado -->
                <div v-if="!visible" class="el-col el-col-24" style="margin-top:30px">                    
                    <hr>
                    <small><i>{{ Correctas }} / 5 Respuestas Correctas.</i></small>
                    <hr>
                    <center v-if="(Correctas)==5">
                        <strong>Aprobado</strong>
                    </center>
                    <center v-if="(Correctas)<5">
                        <strong>Desaprobado</strong><br><br>
                    </center>
                    <div style="margin-top:30px; background:orange; text-align:center; font-size:14px; padding:10px">
                        Gracias por Responder el Cuestionario
                    </div>
                    <el-col :span="24" style="margin-top:50px">
                        <center>
                            <router-link class="el-button el-button--info" style="width:50%"
                            :to="{ name: 'congreso' }">
                                Volver
                            </router-link>
                        </center>
                    </el-col>
                </div>

            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios'

    export default
    {   data()
        {   return {
                idBloqueEncriptado:     btoa(this.$route.params.id),
                idBloque:               this.$route.params.id,                
                Recuperacion:           [],
                Respuestas:             [],
                Pregunta:               [],
                Correctas:              0,
                Total:                  0,
                cargando:               false,
                BtnActivo:              false,
                visible:                true,                
            }
        },


        methods:
        {   Submit()
            {   this.cargando   = true;
                var params      = '';
                var headers     = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                params = params + 'tkn=' + this.$cookies.get('PDTK');
                params = params + '&idBloque=' + this.idBloqueEncriptado;
                params = params + '&idPregunta=' + btoa(this.Pregunta.idPregunta);
                params = params + '&idDisertante=' + btoa(this.Pregunta.idDisertante);
                params = params + '&Respuestas=' + JSON.stringify(this.Respuestas);
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/congreso_rec_in.php', params, {headers: headers})
                    .then(response => {
                        var params  = '';
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        
                        params = params + 'tkn=' + this.$cookies.get('PDTK');
                        params = params + '&idBloque=' + this.idBloqueEncriptado;
                        
                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/congreso_rec_dt.php', params, {headers: headers})
                            .then(response => {
                                const datos                 = response.data;
                                this.Recuperacion           = datos['Recuperacion'];
                                this.Pregunta               = datos['Pregunta'];
                                this.Respuestas             = datos['Respuestas']; 
                                this.Correctas              = datos['Correctas'];
                                this.cargando               = false;
                                if(!this.Pregunta)          this.visible = false;
                                if(!this.Respuestas)        this.visible = false;                                
                                if(this.Recuperacion.length>=5) 
                                {   this.visible            = false;
                                    this.BtnActivo          = false;
                                }                                
                            })
                            .catch(e => {})
                    })
                    .catch(e => {})
            }   
        },


        beforeMount( )
        {   if (!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                params = params + 'tkn=' + this.$cookies.get('PDTK');
                params = params + '&idBloque=' + this.idBloqueEncriptado;
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/congreso_rec_dt.php', params, {headers: headers})
                    .then(response => {
                        const datos                 = response.data;
                        this.Recuperacion           = datos['Recuperacion'];
                        this.Pregunta               = datos['Pregunta'];
                        this.Respuestas             = datos['Respuestas']; 
                        this.Correctas              = datos['Correctas'];
                        this.BtnActivo              = true;
                        if(!this.Pregunta & !this.Respuestas & !this.Recuperacion)
                        {    this.$router.push('../congreso');
                        }
                        if(!this.Pregunta)          this.visible = false;
                        if(!this.Respuestas)        this.visible = false;
                        if(this.Recuperacion.length>=5) 
                        {   this.visible            = false;
                            this.BtnActivo          = false;
                        }                        
                    })
                    .catch(e => {})
            }
        }
    };
</script>



<style>
    .color-0
    {   font-weight: bold;
        color: red;
    }

    .color-1
    {   font-weight: bold;
        color: green;
    }

    .el-radio__label
    {   font-size: 18px;
    }
</style>